export const jpClassTypeId_BeginnerSailing = 1221
export const jpClassTypeId_intermediate1 = 1481
export const jpClassTypeId_intermediate2 = 1482